import { Navbar, Nav, Container, NavDropdown, Badge } from "react-bootstrap";
import { FaUser, FaBell } from "react-icons/fa";
import { LinkContainer } from "react-router-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../slices/userApiSlice";
import { logout } from "../slices/authSlice";
// import { useGetUnreadCountQuery } from "../slices/notificationApiSlice";
import logo from "../assets/logo.png";

const Header = () => {
  const { userInfo } = useSelector((state) => state.auth);
  // const { data, isLoading, isError } = useGetUnreadCountQuery();
  // console.log(data?.count);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [logoutApiCall] = useLogoutMutation();

  const logoutHandler = async () => {
    try {
      await logoutApiCall().unwrap();
      dispatch(logout());
      navigate("/");
    } catch (err) {
      console.error(err);
    }
  };

  const renderRoleBasedLinks = () => {
    if (!userInfo || !userInfo.role) return null;

    switch (userInfo.role) {
      case "vendor":
        return (
          <NavDropdown
            title="Vendor "
            id="vendormenu"
          >
           
            <LinkContainer to="/order">
              <NavDropdown.Item>Sales Order</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/productList">
              <NavDropdown.Item>Product List</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/expiryproductList">
              <NavDropdown.Item>Expiry Date Report</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/inActiveProducts">
              <NavDropdown.Item>InActive Products List</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/createProduct">
              <NavDropdown.Item>Create Product</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/vendorOrdersList">
              <NavDropdown.Item>Sales Orders List</NavDropdown.Item>
            </LinkContainer>
          </NavDropdown>
        );
      case "admin":
        return (
          <NavDropdown title="Admin" id="adminmenu">
                      
            <LinkContainer to="/userList">
              <NavDropdown.Item>Manage Users</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/toggleCard">
              <NavDropdown.Item>Vendor Active Setting</NavDropdown.Item>
            </LinkContainer>
            
            <LinkContainer to="/create-category">
              <NavDropdown.Item>Create Category</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/admin/categories">
              <NavDropdown.Item>Category List</NavDropdown.Item>
            </LinkContainer>
             <LinkContainer to="/informationList">
              <NavDropdown.Item>information List</NavDropdown.Item>
            </LinkContainer>
             <LinkContainer to="/information">
              <NavDropdown.Item>Create Information</NavDropdown.Item>
            </LinkContainer>
            
          </NavDropdown>
        );
 
      default:
        return null;
    }
  };

  return (
    <header>
      <Navbar bg="primary" variant="dark" expand="lg" collapseOnSelect>
        <Container>
          <LinkContainer to="/Home">
  <Navbar.Brand>
    <img
      src={logo}
      alt="KaraikudiMart"
      style={{ height: '40px', marginRight: '10px' }} // Adjust size and spacing
    />
    KaraikudiMart
  </Navbar.Brand>
</LinkContainer>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {/* Role-specific links */}
              {renderRoleBasedLinks()}

              {/* User dropdown */}
              {userInfo ? (
                <NavDropdown title={userInfo.name} id="username">
                  <LinkContainer to="/profile">
                    <NavDropdown.Item>Profile</NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Item onClick={logoutHandler}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <LinkContainer to="/">
                  <Nav.Link>
                    <FaUser /> Sign In
                  </Nav.Link>
                </LinkContainer>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
